<template>
    <ButtonGroup shape="circle" class="container">
        <Button
            v-for="(item, index) in btnArr"
            :key="index"
            :type="currentIndex === index ? 'primary' : 'default'"
            @click="changeIndex(index)"
        >
            <Icon :custom="`iconfont iconfont-${item.iconName}`" />
            {{ item.text }}
        </Button>
    </ButtonGroup>
</template>

<script>
export default {
    name: "ChangeBtn",
    props: {
        btnArr: {
            type: Array,
            default: () => [
                { text: "统计图", iconName: "jingyingbaobiao" },
                { text: "统计表", iconName: "liebiao" },
            ],
        },
        currentIndex: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        changeIndex(index) {
            this.$emit("on-change", index);
        },
    },
};
</script>
